import jwt_decode from 'jwt-decode'
import store from '@/state/store'
import moment from 'moment'
import i18n from '@/i18n'
import { DEVICE_CODE_LIST } from '@/router/views/trackvideo-2/lib/constants/device-code'
moment.locale('id')

export const Helper = {
  methods: {
    /**
     * Current Date Time
     * @param {date} date
     * @returns
     */
    now() {
      return moment().toISOString()
    },
    /**
     * Current Date Time
     * @param {date} date
     * @returns
     */
    today() {
      const now = moment().format('YYYY-MM-DD')
      return [moment(`${now} 00:00:00`).toISOString(), moment(`${now} 23:59:59`).toISOString()]
    },
    /**
     * convert date to ISO String
     * @param {date} date
     * @returns
     */
    momentToISOString(date) {
      return moment(date).toISOString()
    },

    /**
     * convert date to YYYY-MM-DD (2022-12-31)
     * @param {date} date
     * @returns
     */
    momentYmD(date) {
      return moment(date).format('YYYY-MM-DD')
    },

    /**
     * convert date to YYYY-MM-DD (2022-12-31 12:55:22)
     * @param {date} date
     * @returns
     */
    momentYmDHms(date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },

    /**
     * convert date to YYYY-MM-DD (2022-12-31T12:55:22Z)
     * @param {date} date
     * @returns
     */
    momentYmDHmsPayload(date, utc = false) {
      let _date = date
      if (utc) {
        _date = moment(date).utc().format('YYYY-MM-DD HH:mm:ss')
      }
      const timeMinutes = this.momentTimeSeconds(new Date(_date))
      const YMD = this.momentYmD(new Date(_date))
      return `${YMD}T${timeMinutes}Z`
    },

    /**
     * convert date to DD MMMM YYYY HH:mm (31 Agustus 2022 12:55)
     * @param {date} date
     * @returns
     */
    momentDMYH(date) {
      return moment(date).format('DD MMMM YYYY HH:mm')
    },

    /**
     * convert date to DD MMMM YYYY HH:mm:ss (31 Agustus 2022 12:55:20)
     * @param {date} date
     * @returns
     */
    momentDMYHS(date) {
      return moment(date).format('DD MMMM YYYY HH:mm:ss')
    },

    /**
     * convert date to DD MMMM YYYY HH:mm (31 Agu 2022 - 12.55)
     * @param {date} date
     * @returns
     */
    momentDMY_HI(date) {
      return moment(date).format('DD MMM YYYY - HH.mm')
    },

    /**
     * convert date to DD MMMM YYYY HH:mm (18 Agt 17:39)
     * @param {date} date
     * @returns
     */
    momentDMHm(date) {
      return moment(date).format('D MMM HH:mm')
    },

    /**
     * convert date to DD MMMM YYYY HH:mm:ss (18 Agt 17:39:00)
     * @param {date} date
     * @returns
     */
    momentDMHms(date) {
      return moment(date).format('DD MMM YYYY HH:mm:ss')
    },

    momentDMHGmt7(date) {
      if (!date) return null

      if (date.includes('T') && date.endsWith('Z')) {
        const fixed = date.replace(/\.(\d{3})\d+(Z)$/, '.$1$2')

        return moment
          .utc(fixed, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]', true)
          .utcOffset(7)
          .format('DD MMM YYYY HH:mm:ss')
      }

      return moment
        .utc(date, 'DD MMM YYYY HH:mm:ss', true)
        .format('DD MMM YYYY HH:mm:ss')
    },

    momentDMHmsUtc(date) {
      return moment(date).utc().format('DD MMM YYYY HH:mm:ss')
    },

    momentIsoToDMYHms(dateString) {
      if (!dateString) return null

      // Hanya format kalau masih ISO
      if (dateString.includes('T') && dateString.endsWith('Z')) {
        // Potong microseconds jika ada
        const fixed = dateString.replace(/\.(\d{3})\d+(Z)$/, '.$1$2')
        return moment.utc(fixed).format('DD MMM YYYY HH:mm:ss')
      }

      // Kalau bukan ISO, kembalikan apa adanya
      return dateString
    },

    /**
     * convert date to DD MMM YYYY short month
     * @param {date} date
     * @returns
     */
    momentDateShortMonth(date) {
      return moment(date).format('DD MMM YYYY')
    },

    /**
     * convert date to DD MMM YYYY short month
     * @param {date} date
     * @returns
     */
    momentDateLongMonth(date) {
      return moment(date).format('DD MMMM YYYY')
    },

    /**
     * convert date to DD MMM YYYY short month
     * @param {date} date
     * @returns
     */
    momentTime(date) {
      return moment(date).format('HH:mm')
    },

    /**
     * convert date to HH:mm:ss short month
     * @param {date} date
     * @returns
     */
    momentTimeSeconds(date) {
      return moment(date).format('HH:mm:ss')
    },

    momentM(date) {
      return Number(moment(date).format('M'))
    },

    momentY(date) {
      return Number(moment(date).format('YYYY'))
    },

    momentMMM(monthIndex) {
      return moment(Number(monthIndex), 'M').format('MMMM')
    },

    momentYYYYMMDDFromIndex(monthIndex, yearIndex) {
      return moment(`${yearIndex}-${monthIndex}-01 00:00:00`, 'YYYY-MM-DD HH:mm:ss').format(
        'YYYY-MM-DD HH:mm:ss'
      )
    },
    momentAdd(date, num, unit) {
      return moment(date).add(num, unit)
    },
    /**
     * Find range between 2 date
     * @param {date} startDate
     * @param {date} endDate
     * @returns
     */
    getDatesInRange(startDate, endDate) {
      startDate = new Date(startDate)
      endDate = new Date(endDate)
      const date = new Date(startDate.getTime())

      const dates = []

      while (date <= endDate) {
        dates.push(new Date(date))
        date.setDate(date.getDate() + 1)
      }

      return dates
    },

    /**
     * Convert number to time
     * @param {int} num
     * @returns
     */
    minuteToTime(num) {
      const d = Math.floor(num / 1440) // 60*24
      const h = Math.floor((num - d * 1440) / 60)
      const m = Math.round(num % 60)
      if (d != 0) {
        return d + ' hari +'
      } else if (h != 0) {
        return h + ' jam +'
      } else {
        return m + ' menit'
      }
    },

    /**
     * Get Grade from score
     * @param {int} score
     * @returns
     */
    getGrade(score) {
      if (score > 80) {
        return 'A'
      } else if (score <= 80 && score >= 61) {
        return 'B'
      } else if (score <= 60 && score >= 41) {
        return 'C'
      } else if (score <= 40 && score >= 21) {
        return 'D'
      } else {
        return 'E'
      }
    },

    /**
     * Get Company ID from Token
     * @param {int} score
     * @returns
     */
    getCompanyId() {
      if (process.env.VUE_APP_INTEGRATE_IDENTITY === 'true') {
        return store.state.identity.whoami?.companyId
      }
      const token = localStorage.getItem('token')
      if (!token) {
        return false
      }

      const decodedToken = jwt_decode(token)

      return decodedToken.companyId
    },

    /**
     * Get Logged in user name
     * @param {int} score
     * @returns
     */
    getUserName() {
      if (process.env.VUE_APP_INTEGRATE_IDENTITY === 'true') {
        return store.state.identity.whoami?.name
      }
      const token = localStorage.getItem('token')
      if (!token) {
        return false
      }

      const decodedToken = jwt_decode(token)

      if (!decodedToken) {
        return 'Guest'
      }

      return decodedToken.name
    },

    /**
     * Get Logged in user id
     * @param {int} score
     * @returns
     */
    getUserId() {
      if (process.env.VUE_APP_INTEGRATE_IDENTITY === 'true') {
        return store.state.identity.whoami?.userId
      }
      const token = localStorage.getItem('token')
      if (!token) {
        return false
      }

      const decodedToken = jwt_decode(token)

      if (!decodedToken) {
        return null
      }

      return decodedToken.userId
    },

    /**
     *
     * @returns
     *
     */
    getAccessFunc(sub = '') {
      if (process.env.VUE_APP_INTEGRATE_IDENTITY === 'true') {
        return false
      }

      const subCode = localStorage.getItem('rightSub')
      const token = localStorage.getItem('token')
      if (!token) {
        return false
      }

      const decodedToken = jwt_decode(token)

      if (decodedToken) {
        if (subCode.includes(sub)) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },

    /**
     *
     * @returns
     *
     */
    getAccessRight(main = '') {
      if (process.env.VUE_APP_INTEGRATE_IDENTITY === 'true') {
        return false
      }

      const token = localStorage.getItem('token')
      if (!token) {
        return false
      }
      // const tokenAccess = localStorage.getItem('tokenAccess')

      const decodedToken = jwt_decode(token)
      // const decodedAccess = jwt_decode(tokenAccess)

      var rightsCode = localStorage.getItem('right')

      if (decodedToken) {
        if (rightsCode.includes(main)) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },

    /**
     * Get Logged in Access Rights from token
     * @param {string} token
     * @returns
     */
    getAccess() {
      return store.state.identity.whoami?.accessType
    },

    /**
     * Get logged in user image
     * @param {int} score
     * @returns
     */
    getUserPhoto() {
      if (process.env.VUE_APP_INTEGRATE_IDENTITY === 'true') {
        if (!store.state.identity.whoami == null) return 'https://api.dicebear.com/7.x/initials/svg'
        return `https://api.dicebear.com/7.x/initials/svg?seed=${store.state.identity.whoami?.name}`
      }

      const token = localStorage.getItem('token')
      if (!token) {
        return false
      }

      const decodedToken = jwt_decode(token)

      if (!decodedToken) {
        return 'https://api.dicebear.com/7.x/initials/svg'
      }

      return (
        decodedToken.image || `https://api.dicebear.com/7.x/initials/svg?seed=${decodedToken?.name}`
      )
    },

    /**
     * Check user if has access to edit / delete
     * @param {int} score
     * @returns
     */
    hasAccessEditAndDelete(dataCompanyId) {
      const companyId = this.getCompanyId()
      if (!companyId) {
        return false
      }

      if ((companyId == 1 && dataCompanyId == 1) || companyId == dataCompanyId) {
        return true
      }

      return false
    },

    /**
     * Minimize float length to two digit
     * @param {float} score
     * @returns
     */
    minimizeFloat(data) {
      return parseFloat(data).toFixed(2)
    },

    /**
     * Get Days from Hours
     * @param {int} hours
     * @returns
     */
    getDaysFromHours(hours) {
      hours = parseFloat(hours)
      if (hours == 0) return 0
      if (hours < 24) return parseFloat(hours).toFixed(2)
      const days = hours / 24
      return parseFloat(days).toFixed(2)
    },

    /**
     * Check if hours is day or not
     * @param {int} hours
     * @returns
     */
    isDaysOrHours(hours) {
      hours = parseFloat(hours)
      if (hours == 0) return 'Jam'
      if (hours < 24) return 'Jam'

      return 'Hari'
    },

    /**
     * Convert time format to seconds integer
     * @param {int} hours
     * @returns
     */
    convertToSeconds(time) {
      if (time == null || time == '') return 0
      var timeArr = time.split(':')
      timeArr = timeArr.map((item) => parseInt(item))

      var hours = 3600 * timeArr[0]
      var minutes = 60 * timeArr[1]

      return hours + minutes + timeArr[2]
    },

    /**
     * Convert seconds integer to Time Format
     * @param {int} hours
     * @returns
     */
    convertToTime(time) {
      var sec_num = parseInt(time, 10)
      var hours = Math.floor(sec_num / 3600)
      var minutes = Math.floor((sec_num - hours * 3600) / 60)
      var seconds = sec_num - hours * 3600 - minutes * 60

      if (hours < 0) hours *= -1
      if (hours < 10) {
        hours = '0' + hours
      }
      if (minutes < 10) {
        minutes = '0' + minutes
      }
      if (seconds < 10) {
        seconds = '0' + seconds
      }

      return hours + ':' + minutes + ':' + seconds
    },

    /**
     * to Calculate Day from two date
     * @param {int} hours
     * @returns
     */
    calculateDay(date1, date2) {
      date1 = moment(date1)
      date2 = moment(date2)

      var diff = date1.diff(date2, 'days')

      if (diff < 0) diff *= -1

      return diff + 1
    },

    /**
     *
     * @param {number} deviceCode deviceCode
     * @returns ENUM 'jc' | 'bsj'
     */
    getDeviceType(deviceCode) {
      if (DEVICE_CODE_LIST.CONCOX_CAMERA.includes(deviceCode)) return 'jc'
      if (DEVICE_CODE_LIST.FLESPI_HOWEN.includes(deviceCode)) return 'flespi-howen'
      if (DEVICE_CODE_LIST.VSS_HOWEN.includes(deviceCode)) return 'vss-howen'
      if (DEVICE_CODE_LIST.BSJ.includes(deviceCode)) return 'bsj'
      return 'bsj'
    },

    /**
     * to Calculate Day from date to now
     * @param {int} hours
     * @returns
     */
    calculateHours(date2) {
      var date1 = moment()
      date2 = moment(date2)

      var diff = date1.diff(date2, 'hours')

      if (diff < 0) diff *= -1

      return diff + 1
    },

    /**
     * to Calculate Day from date to now
     * @param {int} hours
     * @returns
     */
    calculateMinutes(date1, date2) {
      date1 = moment(date1)
      date2 = moment(date2)
      var diff = date1.diff(date2, 'minutes')

      if (diff < 0) diff *= -1

      return diff + 1
    },

    /**
     * user activity log
     * @param {*} action
     * @param {*} data
     */
    userLogging(action, data) {
      const input = {
        activity: action,
        path: `${data.name}`,
      }
      return input
    },

    /**
     * Duration to minutes
     */
    durationToMinutes(duration, durationOption) {
      var optionValue = {
        Menit: 1,
        Jam: 60,
        Hari: 1440,
        Minggu: 10080,
        Bulan: 43800,
      }

      return parseInt(duration) * optionValue[durationOption]
    },

    /**
     * Get Duration Option
     */
    getDurationOption(duration) {
      var optionValue = {
        Bulan: 43800,
        Minggu: 10080,
        Hari: 1440,
        Jam: 60,
        Menit: 1,
      }
      var keys = Object.keys(optionValue)
      var result = 'Menit'
      var resultValue = 0

      for (let index = 0; index < keys.length; index++) {
        if (duration % optionValue[keys[index]] === 0) {
          result = keys[index]
          resultValue = duration / optionValue[keys[index]]
          break
        }
      }

      return { value: resultValue, option: result }
    },
    thousandFormat(data) {
      const number = Number(data).toLocaleString('id-ID', { maximumFractionDigits: 2 })
      return number
    },
    portKeydown(e, preventZeroFirst = false, preventComma = false) {
      if (e.key === 'Backspace') {
        return
      }

      const currentValue = e.target.value
      const keyPressed = e.key

      // Zero first prevent
      if (!preventZeroFirst && currentValue.length === 0 && keyPressed === '0') {
        e.preventDefault()
        return
      }

      // Negative prevent
      if (
        (keyPressed === '-' && !currentValue.includes('-')) ||
        (keyPressed === 'ArrowDown' && currentValue.length === 0) ||
        (keyPressed === 'ArrowDown' && parseInt(currentValue) - 1 < 0) ||
        (keyPressed === 'e' && !currentValue.includes('e')) ||
        (!preventZeroFirst && keyPressed === 'ArrowDown' && parseInt(currentValue) - 2 < 0)
      ) {
        e.preventDefault()
        return
      }

      if (preventComma && (keyPressed === '.' || keyPressed === ',')) {
        e.preventDefault()
        return
      }
    },
    preventTabKey(event) {
      if (!event) return
      if (event.keyCode === 9) {
        // Tab key
        event.preventDefault()
      }
    },
    formatDate(e) {
      const dateRaw = new Date(e)
      const date = new Date(
        Date.UTC(
          dateRaw.getFullYear(),
          dateRaw.getMonth(),
          dateRaw.getDate(),
          dateRaw.getHours(),
          dateRaw.getMinutes(),
          dateRaw.getSeconds()
        )
      )
      moment.locale('en')

      return moment(date).utcOffset('+07:00').format('DD MMM YYYY HH:mm:ss')
    },

    formatDateUtc(e) {
      const dateRaw = new Date(e)
      const date = new Date(
        Date.UTC(
          dateRaw.getFullYear(),
          dateRaw.getMonth(),
          dateRaw.getDate(),
          dateRaw.getHours(),
          dateRaw.getMinutes(),
          dateRaw.getSeconds()
        )
      )
      moment.locale('en')

      return moment(date).utc().format('DD MMM YYYY HH:mm:ss')
    },

    motionStatusFormat(param) {
      let label
      switch (param) {
        case 'M':
          label = i18n.t('liveView.filter.moving')
          break
        case 'P':
          label = i18n.t('liveView.filter.parking')
          break
        case 'I':
          label = i18n.t('liveView.filter.idle')
          break
        case 'A':
          label = i18n.t('liveView.filter.assisted')
          break
        case 'O':
          label = i18n.t('liveView.filter.offline')
          break
        case 'U':
          label = i18n.t('liveView.filter.unknown')
          break
        default:
          break
      }

      return label
    },

    motionStatusColor(motion) {
      let color = 'secondary'
      switch (motion) {
        case 'M':
          color = 'success'
          break
        case 'I':
          color = 'warning'
          break
        case 'P':
          color = 'danger'
          break
        default:
          color = 'secondary'
          break
      }

      return color
    },

    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },

    getRelativeTime(timestamp) {
      const now = new Date();
      const past = new Date(timestamp);
      const diffMs = now - past;
      const diffSeconds = Math.floor(diffMs / 1000);
      const diffMinutes = Math.floor(diffSeconds / 60);
      const diffHours = Math.floor(diffMinutes / 60);
      const diffDays = Math.floor(diffHours / 24);
      const diffWeeks = Math.floor(diffDays / 7);
      const diffMonths = Math.floor(diffDays / 30);
      const diffYears = Math.floor(diffDays / 365);

      if (diffSeconds < 60) {
        return diffSeconds === 1 ? '1s ago' : `${diffSeconds}s ago`;
      } else if (diffMinutes < 60) {
        return diffMinutes === 1 ? '1m ago' : `${diffMinutes}m ago`;
      } else if (diffHours < 24) {
        return diffHours === 1 ? '1h ago' : `${diffHours}h ago`;
      } else if (diffDays < 7) {
        return diffDays === 1 ? '1 day ago' : `${diffDays} days ago`;
      } else if (diffWeeks < 4) {
        return diffWeeks === 1 ? '1 week ago' : `${diffWeeks} weeks ago`;
      } else if (diffMonths < 12) {
        return diffMonths === 1 ? '1 month ago' : `${diffMonths} months ago`;
      } else {
        return diffYears === 1 ? '1 year ago' : `${diffYears} years ago`;
      }
    }
  },
}

export function debounce(fn, delay) {
  var timeoutID = null
  return function () {
    clearTimeout(timeoutID)
    var args = arguments
    var that = this
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}
